export const EnumAlign = {
	None: "None",
	TopLeft: "TopLeft",
	TopCenter: "TopCenter",
	TopRight: "TopRight",
	Center: "Center",
	BottomLeft: "BottomLeft",
	BottomCenter: "BottomCenter",
	BottomRight: "BottomRight",
};
export const fontList = [
	"American Typewriter",
	"Andalé Mono",
	"Arial",
	"Arial Black",
	"Bradley Hand",
	"Brush Script MT",
	"Courier",
	"Courier New",
	"Comic Sans MS",
	"Didot",
	"Georgia",
	"Helvetica",
	"Impact",
	"Lucida Console",
	"Luminari",
	"Monaco",
	"Sans-serif",
	"Verdana",
	"Tahoma",
	"Times New Roman",
	"Trebuchet MS",
];

